import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Lock, User, Heart } from 'lucide-react';

const ProtectedRoute = ({ children, fallback }) => {
  const { user, loading, openAuthModal } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-orange-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    if (fallback) {
      return fallback;
    }

    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-orange-50 flex items-center justify-center px-4">
        <Card className="max-w-md w-full text-center border-0 shadow-xl">
          <CardHeader className="pb-4">
            <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-orange-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <Lock className="w-8 h-8 text-white" />
            </div>
            <CardTitle className="text-2xl font-bold text-gray-800">Authentication Required</CardTitle>
            <CardDescription className="text-base">
              Please sign in to access your pet profiles and create custom recipes
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Button 
                onClick={() => openAuthModal('login')}
                className="w-full bg-gradient-to-r from-green-500 to-orange-500 hover:from-green-600 hover:to-orange-600"
                data-testid="auth-required-login-btn"
              >
                <User className="w-4 h-4 mr-2" />
                Sign In
              </Button>
              <Button 
                onClick={() => openAuthModal('signup')}
                variant="outline"
                className="w-full border-green-300 text-green-700 hover:bg-green-50"
                data-testid="auth-required-signup-btn"
              >
                Create Account
              </Button>
            </div>
            
            <div className="pt-4 border-t border-gray-100">
              <p className="text-sm text-gray-600 mb-3">With an account you can:</p>
              <ul className="text-sm text-gray-700 space-y-1 text-left">
                <li className="flex items-center gap-2">
                  <Heart className="w-4 h-4 text-green-500" />
                  Save multiple pet profiles
                </li>
                <li className="flex items-center gap-2">
                  <Heart className="w-4 h-4 text-green-500" />
                  Create custom recipes using AAFCO nutrient guidelines
                </li>
                <li className="flex items-center gap-2">
                  <Heart className="w-4 h-4 text-green-500" />
                  Get AI-powered recipe recommendations
                </li>
                <li className="flex items-center gap-2">
                  <Heart className="w-4 h-4 text-green-500" />
                  Track nutritional requirements
                </li>
              </ul>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;